import {getApiProps} from "@/lib/lib";
// import {objectComparison} from "@/lib/lib";
const with_removed = String(process.env.VUE_APP_PACKAGE).includes('admin') ? {'force[with_removed]': 1} : {}
const changedField = 'changed_at';

const collator = new Intl.Collator();
const sortByName = function (a, b) {
    let cmp = collator.compare(a?.name_ || '', b?.name_ || '')
    if (cmp) {
        return cmp;
    }
    return a.id - b.id;
}

let _orchestratorUsersIndexCache = {arr: null, map: null}
function getOrchestratorUsersIndexMap(state) {
    if (_orchestratorUsersIndexCache.arr !== state.orchestratorUsers) {
        _orchestratorUsersIndexCache.map = new Map(state.orchestratorUsers.map((u, i) => [u.id, i]))
        _orchestratorUsersIndexCache.arr = state.orchestratorUsers
    }
    return _orchestratorUsersIndexCache.map
}

export default {
    state: {
        orchestratorUsersLiteLoad: false,
        orchestratorUsersFullLoad: false,
        orchestratorUsers: [],
    },
    actions: {
        fetchOrchestratorAppUser({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !getters.getAppUserId) {
                    return reject(false)
                }
                const params = getApiProps('orchestratorAppUser', args)
                dispatch('setLastCall', {name: 'fetchOrchestratorAppUser', args, time: Date.now() / 1000})

                this.$api.orchestrator.getUsers(getters.getAppUserId, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateOrchestratorUser', response.data)
                            resolve(true)
                        } else {
                            console.error(response);
                            reject(false)
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(false)
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchOrchestratorAppUser', args, inprogress: false})
                    });
            });
        },
        fetchOrchestratorUsers/*all*/({dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }

                dispatch('setLastCall', {name: 'fetchOrchestratorUsers', args, time: Date.now() / 1000})

                const params = getApiProps('orchestratorUsers', args)
                this.$api.orchestrator.getUsers(null, {...params, ...with_removed})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchOrchestratorUsers', args, inprogress: false})
                    });
            })
        },
        fetchOrchestratorUser({commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !args.id) {
                    return reject(false)
                }
                const params = getApiProps('orchestratorUsers', args)
                delete params.id;
                this.$api.orchestrator.getUsers(args.id, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateOrchestratorUser', response.data)
                            resolve(true)
                        } else {
                            console.error(response);
                            reject(false)
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(false)
                    });
            });
        },

        saveOrchestratorUser({dispatch}, orchestratorUser) {
            let fn = (orchestratorUser.id) ? 'updateOrchestratorUser' : 'createOrchestratorUser'
            return dispatch(fn, orchestratorUser);
        },
        createOrchestratorUser({commit, dispatch}, orchestratorUser) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('orchestratorUsers')
                this.$api.orchestrator.create(orchestratorUser, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateOrchestratorUser', response.data)
                            dispatch('fetchOrchestratorUsersChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        updateOrchestratorUser({commit, dispatch}, orchestratorUser) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('orchestratorUsers')
                this.$api.orchestrator.update(orchestratorUser.id, orchestratorUser, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateOrchestratorUser', response.data)
                            dispatch('fetchOrchestratorUsersChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },

        deleteOrchestratorUser({commit, dispatch}, id) {//remove
            return new Promise((resolve, reject) => {
                const params = getApiProps('orchestratorUsers')
                this.$api.orchestrator.delete(id, {...params, ...with_removed})//remove
                    .then((response) => {
                        if (response.status < 400 && (!response.data || !response.data?.error)) {
                            if (!response.data) commit('deleteOrchestratorUser', id)
                            else commit('updateOrchestratorUser', response.data)
                            dispatch('fetchOrchestratorUsersChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
    },
    mutations: {
        setOrchestratorUsersLiteLoad(state, LiteLoad) {
            state.orchestratorUsersLiteLoad = state.orchestratorUsersLiteLoad || LiteLoad
        },
        setOrchestratorUsersFullLoad(state, FullLoad) {
            state.orchestratorUsersFullLoad = state.orchestratorUsersFullLoad || FullLoad
        },

        setOrchestratorUsers(state, nOrchestratorUsers) {
            nOrchestratorUsers = nOrchestratorUsers.map(u => {
                //if (u?.name) u.name_ = u.name.toLocaleLowerCase()
                return Object.freeze(u)
            })
            nOrchestratorUsers.sort(sortByName)
            state.orchestratorUsers = nOrchestratorUsers
        },

        updateOrchestratorUsers(state, nOrchestratorUsers) {
            if (!state.orchestratorUsers.length) {
                nOrchestratorUsers = nOrchestratorUsers.map(u => {
                    //if (u?.name) u.name_ = u.name.toLocaleLowerCase()
                    return Object.freeze(u)
                })
                nOrchestratorUsers.sort(sortByName)
                state.orchestratorUsers = nOrchestratorUsers
                return true
            }

            // console.log('updateOrchestratorUsers', state.orchestratorUsers.length)
            const indexById = getOrchestratorUsersIndexMap(state)
            nOrchestratorUsers.forEach(function (nOrchestratorUser) {
                let i = indexById.has(nOrchestratorUser.id) ? indexById.get(nOrchestratorUser.id) : -1
                if (i < 0) {
                    indexById.set(nOrchestratorUser.id, state.orchestratorUsers.length)
                    state.orchestratorUsers.push(Object.freeze(nOrchestratorUser))
                } else
                if (!state.orchestratorUsersFullLoad || state.orchestratorUsers[i][changedField] != nOrchestratorUser[changedField]) {
                    // updateObjectByDiff(state.orchestratorUsers[i], nOrchestratorUser)
                    delete nOrchestratorUser.id
                    state.orchestratorUsers[i] = Object.freeze({...state.orchestratorUsers[i], ...nOrchestratorUser})
                }
            })
        },
        filterOrchestratorUsers(state, nOrchestratorUsers) {
            // let Ids = state.orchestratorUsers.map(u=> u.id)
            let nIds = new Set(nOrchestratorUsers.map(u => u.id))
            state.orchestratorUsers = state.orchestratorUsers.filter(u => nIds.has(u.id))
        },
        updateOrchestratorUser(state, nOrchestratorUser) {
            if(!nOrchestratorUser) return false;
            let i = state.orchestratorUsers.findIndex(u => (u.id == nOrchestratorUser.id))
            if (i < 0) {
                state.orchestratorUsers.push(Object.freeze(nOrchestratorUser))
            } else
            //if (state.orchestratorUsers[i][changedField] != nOrchestratorUser[changedField])
            {
                // updateObjectByDiff(state.orchestratorUsers[i], nOrchestratorUser)
                let orchestratorUser = {...nOrchestratorUser} //ToDo fix
                delete orchestratorUser.id
                state.orchestratorUsers[i] = Object.freeze({...state.orchestratorUsers[i], ...orchestratorUser})
            }
        },
        deleteOrchestratorUser(state, id) {
            let i = state.orchestratorUsers.findIndex(u => (u.id == id))
            if (i != -1) {
                state.orchestratorUsers.splice(i, 1)
            }
        },
        clearOrchestratorUsers(state) {
            state.orchestratorUsers = []
            state.orchestratorUsersLiteLoad = false
            state.orchestratorUsersFullLoad = false
        },
    },
    getters: {
        isOrchestratorUsersLiteLoad(state) {
            return state.orchestratorUsersLiteLoad
        },
        isOrchestratorUsersFullLoad(state) {
            return state.orchestratorUsersFullLoad
        },
        getOrchestratorUsers(state) {
            return state.orchestratorUsers
        },
        getOrchestratorUsersByIds(state) {
            return state.orchestratorUsers.reduce((orchestratorUsersByIds, u) => {
                orchestratorUsersByIds[u.prometheus_id] = u
                return orchestratorUsersByIds
            }, {})
        },
    }
}
